module.exports = __webpack_public_path__ + "img/announcement.d65c1edf.svg";